const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // Default fallback for development
  let hostname = window.location.hostname;
  if (hostname.startsWith('admin.')) {
    hostname = hostname.substring(6); // remove 'admin.'
  }
  return `http://${hostname}:8000`;
};

export const BACKEND_URL = getBackendUrl();
const API_BASE_URL = `${BACKEND_URL}/api/v1/`;

export default API_BASE_URL;
